module.exports = __webpack_public_path__ + "img/logo.562fb661.png";